import React, { useEffect, useRef, useState } from "react";
import { SlTooltip } from "@shoelace-style/shoelace/dist/react";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import backSvg from "../../../assets/images/arrow_back_icon.svg";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import TableLoader from "../../../shared/TableLoader";
import NoDataFound from "../../../shared/NoDataFound";
import { CSVLink } from "react-csv";
import {
  customReportDimensions,
  customReportHeaders,
  customReportMetrics,
  formatSpentValue,
} from "../../../utils/constants";
const customReportMetricsValues = customReportMetrics.map((i) => i.value);

function CustomReportGeneration(props) {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [sortOn, setSortOn] = useState({
    sortByHeader: null,
    sortOrder: "desc",
  });
  const csvLinkRef = useRef(); // Create a ref for CSVLink

  const getReport = async () => {
    try {
      setLoader(true);
      let res = await API({
        url: "/custom_reports/get-report-data",
        method: "POST",
        responseType: "json",
        data: props.APIbody || {},
      });
      if (res.code === 200) {
        setData(res.data?.report || []);
        setHeaders(res.data?.headers || []);
      } else {
        Toast("error", res.message);
      }
      setLoader(false);
    } catch (error) {
      console.error("Error @ getReport", error);
      setLoader(false);
    }
  };
  useEffect(() => {
    getReport();
  }, []);
  const handleSortByHeader = (header) => {
    setSortOn({
      sortByHeader: header,
      sortOrder: sortOn.sortOrder === "desc" ? "asc" : "desc",
    });

    setData(
      data.sort((a, b) => {
        if (sortOn.sortOrder === "desc") return b[header] - a[header];
        else return a[header] - b[header];
      })
    );
  };

  /** CSV Export Data */
  const metricHeaders = customReportMetricsValues.filter((i) =>
    headers.includes(i)
  );
  const totalRow = {};
  metricHeaders.forEach((header) => {
    totalRow[header] = data.reduce((acc, item) => acc + (item[header] || 0), 0);
  });
  const csvData = [...data, { ...totalRow, Total: "Total" }];

  const handleDownloadReport = () => {
    try {
      if (data.length) csvLinkRef?.current?.link?.click();
    } catch (error) {
      console.error("Error @ handleDownloadReport", error);
    }
  };
  return (
    <div>
      <CSVLink
        data={csvData}
        headers={headers.map((item) => ({ label: item, key: item }))}
        filename={(props.report_name || "report") + ".csv"}
        ref={csvLinkRef}
        style={{ display: "none" }}
      />

      <header className="d-flex gap-2 items-center justify-between">
        <div className="d-flex gap-2 items-center justify-start">
          <button onClick={() => props.onBack()} className="w-7" type="button">
            <img src={backSvg} alt="close" />
          </button>
          <h3>{props.report_name} Report</h3>
        </div>
        <button>
          <SlIcon
            library="lucide"
            name="download"
            className="w-4 font-bold cursor-pointer"
            onClick={() => handleDownloadReport()}
          ></SlIcon>
        </button>
      </header>
      <table className="table table-bordered">
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>
                {customReportHeaders.find(
                  (tempheader) => tempheader.value === header
                )?.label || header}
                {customReportMetricsValues
                  .filter((i) => headers.includes(i))
                  .includes(header) ? (
                  <SlTooltip content="sort">
                    <SlIcon
                      library="lucide"
                      className="w-4 font-bold cursor-pointer"
                      onClick={() => handleSortByHeader(header)}
                      name={
                        sortOn.sortOrder === "desc" &&
                        sortOn.sortByHeader === header
                          ? "arrow-down"
                          : "arrow-up"
                      }
                    ></SlIcon>
                  </SlTooltip>
                ) : null}
              </th>
            ))}
          </tr>
        </thead>
        {data?.length && !loader ? (
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                {headers.map((header) => (
                  <td key={header} title={item[header]}>
                    {customReportMetricsValues.includes(header)
                      ? formatSpentValue(item[header])
                      : item[header]}
                  </td>
                ))}
              </tr>
            ))}
            <tr>
              <td
                colSpan={
                  headers.length -
                  customReportMetricsValues.filter((i) => headers.includes(i))
                    .length
                }
                className="text-right"
              >
                Total
              </td>
              {customReportMetricsValues
                .filter((i) => headers.includes(i))
                .map((header) => (
                  <td
                    key={header}
                    title={data.reduce((acc, item) => acc + item[header], 0)}
                  >
                    {formatSpentValue(
                      data.reduce((acc, item) => acc + item[header], 0)
                    )}
                  </td>
                ))}
            </tr>
          </tbody>
        ) : !data?.length && !loader ? (
          <NoDataFound colspan="15" />
        ) : (
          <TableLoader colspan="15" />
        )}
      </table>
    </div>
  );
}

export default CustomReportGeneration;
